// this probably will be used in the future
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  // we init with resources
  resources: {
    en: {
      translations: {
        searchStops: "Search stops",
        upgradePlan: "Upgrade plan",

        // Import
        uploadStops: "Upload stops",
        uploadVehicles: "Upload vehicles",
        uploadDrivers: "Upload drivers",
        templateFiles: "Template file",
        dropExcel: "Drop Excel file here",
        dropHere: "Drop here",
        or: "OR",
        browse: "Browse",
        supportedFileFormats: "Supported file formats",
        requiredFields: "Required fields",
        requiredFieldsText:
          "Columns should be in the correct order and fields with marked with * are required (street* + housenumber* + zipcode* OR lat* + lon*, and country*).",

        // Project settings,
        projectSettings: "Project settings",
        distanceUnits: "Distance units",
        optimizationAlgorithm: "Optimization algorithm",
        fastestTime: "Fastest time",
        shortestDistance: "Shortest distance",
        defaultDuration: "Default duration",
        defaultLoad: "Default load",
        units: "Units",
        allowLateStops: "Allow late stops",
        allowBackhaul: "Allow backhaul",
        fixedDeparture: "Fixed departure time",

        cancel: "Cancel",
        save: "Save",

        //  Project
        stops: "Stops",
        vehicles: "Vehicles",
        addFirstStop: "Add first stop location",
        addSecondStop: "Add second stop location",
        addStop: "Add stop",
        addStopLocation: "Add stop location",
        addAnotherStop: "Add another stop"
      }
    },
    de: {
      translations: {
        searchStops: "Serchulu stopulu"
      }
    }
  },
  fallbackLng: "en",
  debug: true,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false
  }
});

export default i18n;
